<template>
  <div class="ai-background">
    <h3
      v-if="
        chatReady && assistantModel && assistantModel.display_assistant_name
      "
      class="ma-2"
    >
      {{ assistantName }}
    </h3>
    <div
      v-if="chatReady && assistantList && !hideAssistantsList"
      class="assistant-list"
    >
      <v-list flat>
        <v-list-item
          @click="getMessages(c)"
          text
          v-for="c in chats"
          :key="c._id"
        >
          <v-icon>mdi-wechat</v-icon>
          {{ c ? c.name : "" }}
        </v-list-item>
      </v-list>
    </div>
    <v-list
      class="thread-list"
      v-if="
        !hideThreads &&
          chatReady &&
          assistantModel &&
          assistantModel.show_all_threads
      "
    >
      <v-btn
        class="ml-4 mb-2"
        color="info"
        v-if="assistant_id && !hideNewChat"
        text
        @click="selectThread('')"
      >
        <v-icon class="ma-2">mdi-chat</v-icon> New Chat</v-btn
      >

      <v-list-item v-for="(t, i) in threads" :key="i">
        <v-btn color="info" text @click="selectThread(t.thread_id)">
          <v-icon class="ma-2">mdi-chat-question-outline</v-icon>
          <span class="">{{ messages[messages.length - 1].caption }}</span>
        </v-btn>
        <v-btn color="error" class="ma-2" @click="deleteThread(t)" icon
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </v-list-item>
    </v-list>

    <hr />

    <v-list
      class="pa-2"
      :key="msgKey"
      :style="'height:' + messageListHeight + 'px; min-width: 300px'"
      id="message-list"
    >
      <v-list-item class="ma-2" v-if="!thread_id">
        <v-icon color="green" large> mdi-assistant > </v-icon
        >{{ initialMessage }}</v-list-item
      >
      <v-list-item
        :class="message.class + ' d-flex align-start ma-2'"
        :style="'background-color:' + message.color"
        v-for="(message, index) in messages.filter((m) => {
          return m.thread_id == thread_id;
        })"
        :key="index"
      >
        <!-- message:{{ message }} -->
        <v-icon
          :color="message.role == 'assistant' ? 'green' : 'blue'"
          large
          class="ma-2"
        >
          {{
            message.role == "assistant" ? "mdi-assistant" : "mdi-account"
          }}</v-icon
        >

        <v-list-item-content
          v-if="message.content"
          class="ma-2 message"
          v-html="convertMarkdownLinksToHTML(message.content)"
        >
        </v-list-item-content>
        <!-- <div class="ma-4" v-else>{{ defaultMessage }}</div> -->
      </v-list-item>
      <v-row style="overflow: hidden" v-if="loading && !streaming">
        <v-col cols="12" md="auto">
          <v-img style="height: 40px; width: 40px" :src="actionImage" />
        </v-col>
        <v-col cols="12" md>
          <v-card flat style="overflow: hidden">
            <v-card-text>
              <p>{{ actionMessage }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <div v-if="loading && streaming" class="chat-bubble">
        <div class="typing">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>

      <v-list-item v-if="loading">
        <span v-if="runningFunction && !streaming">checking data...</span>

        <div
          v-if="streaming"
          class="streaming"
          v-html="convertMarkdownLinksToHTML(streaming)"
        ></div>
      </v-list-item>
    </v-list>
    <div
      :class="!listHeight ? 'fixed ml-4' : 'ml-4'"
      :style="uploadImages ? 'height:280px' : 'height:120px'"
    >
      <v-alert
        class="ma-4"
        timeout="3000"
        dismissible
        v-if="errorMessage != '' && errorMessage"
        type="error"
      >
        {{ errorMessage }}
      </v-alert>
      <v- row v-if="uploadImages">
        <v-col>
          <div class="image-block">
            <v-upload objectName="aichat" :formModel="formModel"></v-upload>
          </div>
        </v-col>
      </v->
      <v-row>
        <v-col>
          <v-text-field
            class="ma-2"
            v-model="newMessage"
            :placeholder="
              defaultToolTip
                ? defaultToolTip
                : 'Ask ' + capitalize(assistantModel ? assistantModel.name : '')
            "
            append-icon="mdi-send"
            prepend-icon="mdi-paperclip"
            ref="userText"
            @click:append="askAssistant()"
            @click:prepend="uploadImages = !uploadImages"
            @keydown.enter="askAssistant()"
            v-if="chatReady && !loading && assistant_id"
          >
            <template #prepend>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    @click="uploadImages = !uploadImages"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-paperclip</v-icon
                  >
                </template>
                <span>{{
                  uploadImages ? "Hide Upload" : "Upload images"
                }}</span>
              </v-tooltip>
            </template>

            <template #append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon @click="askAssistant()" v-bind="attrs" v-on="on"
                    >mdi-send</v-icon
                  >
                </template>
                <span>Send Request</span>
              </v-tooltip>
            </template>
          </v-text-field>
          <div v-if="loading && !streaming">
            <!-- <v-loading-icon></v-loading-icon> -->
            <i class="mdi mdi-loading mdi-spin ma-2"></i>
            Loading ...
          </div>
          <v-btn @click="cancelRequest" text color="error" v-if="loading">
            <v-icon class="ma-2">mdi-stop-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-confirm ref="confirm"></v-confirm>
  </div>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";

import showdown from "showdown";
import io from "socket.io-client";
export default {
  props: {
    hideAssistantsList: Boolean,
    hideNewChat: Boolean,
    hideThreads: Boolean,
    defaultMessage: String,
    defaultToolTip: String,
    // customInstructions: String,
    listHeight: Number,
    noStreaming: Boolean,
    existingThreadId: String,
    objectAssistantId: String,
    dataObject: Object,
  },
  data: () => ({
    assistantList: true,
    assistant_id: "",
    assistantName: "",
    initialMessage: "",
    assistantModel: null,
    assistantId: "",
    threads: [],
    thread_id: "",
    instructions: "",
    newMessage: "",
    msgKey: 0,
    headers: null,
    models: [],
    messages: [],
    chats: [],
    delay: 0,
    // rules: [(v) => !!v || "Input is required"],
    socket: null,
    // url: "https://api.openai.com/v1/chat/completions",
    url: "http://localhost:5001/completions",
    chatGPT: false,
    session: new Date(),
    user_id: "",
    resendInterval: 20000,
    loading: false,
    errorMessage: "",
    gptMessages: [],
    totalPrice: 0,
    totalTokens: 0,
    systemMessage: {},
    functions: [],
    chatReady: false,
    userData: {},
    currentFunction: "",
    excludedData: [],
    addresses: [],
    tools: [],

    shipmentKey: 0,
    charges: null,
    shipmentReady: false,
    runningFunction: false,
    streaming: "",
    model: null,
    clear: false,
    speechEnabled: false,
    loadingText: "",
    defaultLoadingText:
      "Your message is received and processing... Click to resend",
    companyName: "Four Winds Relocation LLC",
    companyId: "5de16757bec0b423ddcd3507",
    portal_id: "85",
    cancelTokenSource: null,

    captionPrompt__:
      "Also, please create a curEst for the task. Provide the caption as an annotation in the format: <annotation type='caption'>[Your caption here]</annotation> without including the annotation in your response",
    captionPrompt_:
      "Also, please create a caption for the task. Provide the caption as an annotation without including the annotation in your response",
    caption: "",
    functionDescription: {
      get_geo: "Validating Address",
      submit_lead: "Updating your shipment information",
      calculate_shipment: "Calculating Your Move",
      book_move: "Booking Your Move",
      get_web_info: "Getting info from the web...",
    },
    actionMessage: "",
    actionImage: "",
    defaultActionImage: "brainstorming.gif",
    defaultActionMessage: "Analyzing your input...",
    createdCaption: "",
    formModel: {},
    uploadImages: false,
    images: [
      // "https://portal85.moverai.com/user_images/portal_85/bedroom.jpg",
      // "https://portal85.moverai.com/user_images/portal_85/bedroom2.jpg",
    ],
    routeId: "",
  }),

  components: {
    // eslint-disable-next-line vue/no-unused-components
    // VShipment: () => import("@/views/Shipment.vue"),
    VConfirm: () => import("@/components/Confirm.vue"),
    VUpload: () => import("@/components/UploadDragDrop.vue"),
    // VLoadingIcon: () => import("@/components/LoadingIcon.vue")
  },

  created() {},
  mounted() {
    var that = this;
    // this.routeId = this.$route.params.id;
    // if (this.hideThreads) {
    //   this.thread_id = "";
    // }
    // if (this.existingThreadId) {
    //   this.thread_id = this.existingThreadId;
    // } else {
    //   this.thread_id = "";
    // }
    this.$root.$on("gotFiles", (f) => {
      console.log(f);
    });
    this.cancelTokenSource = null;

    this.focusOnText();
    this.initSocket();
    if (!this.chat_id) {
      var id = this.$router.currentRoute.params.id;
      if (id) {
        this.assistantId = id.split("-")[0];
        try {
          this.companyId = id.split("-")[1];
        } catch (error) {
          //
        }
      }

      try {
        this.getCompany();
      } catch (error) {
        //
      }

      // } else {
      //   this.assistantId = this.chat_id;
    }
    this.formModel._id = this.assistantId;
    if (this.objectAssistantId) {
      this.assistantId = this.objectAssistantId;
    }

    if (this.assistantId) {
      this.assistantList = false;
    }

    this.$root.$on("fileUploaded", (d) => {
      console.log(d);

      that.images.push(d.response.path);
    });
    this.$root.$on("fileDeleted", (d) => {
      let index = that.images.indexOf(d.file.path);

      if (index !== -1) {
        that.images.splice(index, 1);
      }
    });
    this.socket.on("chunk_received", (d) => {
      console.log(d);
      var systemMessage = {};
      if (that.user_id == d.user) {
        if (d.caption) {
          console.log(d.caption);
          that.caption = d.caption;
        }
        if (d.json) {
          d.userMessage = this.newMessage;
          that.$root.$emit("responseFromAssistant", d);
          systemMessage = {
            content: that.streaming,
            thread_id: that.thread_id,
            role: "assistant",
          };
          systemMessage = {
            content: "completed " + d.caption,
            thread_id: that.thread_id,
            role: "assistant",
          };

          that.loading = false;
          that.messages.push(systemMessage);

          return;
        }
        if (d.end_of_stream) {
          //
          that.loading = false;
          if (that.streaming.toLocaleLowerCase().includes("upload images")) {
            // that.uploadImages = true;
            that.images = ["https://portal85.moverai.com/user_images/room.jpg"];
          }

          // that.thread_id = d.thread_id;
          // that.systemMessage.thread_id = that.thread_id;
          systemMessage = {
            content: that.streaming,
            thread_id: that.thread_id,
            role: "assistant",
          };

          if (systemMessage.content) {
            that.messages.push(systemMessage);

            that.focusOnText();
            that.scrollToBottom();
            that.chatReady = true;
            that.msgKey = !that.msgKey;
          }
        } else {
          if (d.running_function) {
            var action = this.functionDescription[d.running_function];

            that.actionImage = d.running_function + ".gif";

            var description = action;

            that.actionMessage = description + "...";
          } else {
            that.actionMessage = this.defaultActionMessage;
            that.actionImage = this.defaultActionImage;
            that.runningFunction = false;
            // setTimeout(function () {
            that.streaming += d.text;
            that.thread_id = d.thread_id;
            that.createdCaption = d.caption;
            if (that.messages.length == 1) {
              that.messages[0].thread_id = that.thread_id;
            }
            that.scrollToBottom();
          }
        }
      }
    });

    if (this.$root.user_id) {
      this.user_id = this.$root.user_id;
    } else {
      this.user_id = localStorage.getItem("user_id");
      if (!this.user_id) {
        this.user_id = fun.guid();
        localStorage.setItem("user_id", this.user_id);
        this.user_id = localStorage.getItem("user_id");
      }
    }

    if (this.speechEnabled) {
      this.speechToText();
    }
    document.arrive("div", (a) => {
      if (a) {
        that.scrollToBottom();
      }
    });

    this.getAssistants();
  },
  methods: {
    askAssistant() {
      var that = this;
      // that.uploadImages = true;
      this.scrollToBottom();
      var userMessage = {
        content: this.newMessage,
        thread_id: this.thread_id,

        role: "user",
      };
      that.messages.push(userMessage);

      setTimeout(that.callOpenAI(), 500);
    },
    initSocket() {
      var socketUrl = fun.getSocketURL();
      socketUrl = "https://server.moverai.com:5000";

      this.socket = io(socketUrl);
    },
    focusOnText() {
      this.$nextTick(() => {
        if (this.$refs.userText) {
          this.$refs.userText.focus();
        }
      });
    },
    capitalize(text) {
      return fun.capitalize(text);
    },
    getCompany() {
      var data = {
        object_name: "company",
        db_name: "emover_" + this.portal_id,
        qry: { _id: this.companyId },
      };
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          var data = response.data;
          try {
            this.companyName = data.model[0].company_name;
          } catch (error) {
            //
          }

          console.log(data);
        });
    },
    getMessages(a) {
      var that = this;
      var data = {
        object_name: "ai_messages",
        qry: {
          $and: [{ user_id: this.user_id }, { assistant_id: a.assistant_id }],
        },

        db_name: "admin",
      };
      axios
        .post(this.serverURL + "/get_data", data, {
          withCredentials: true,
        })
        .then((response) => {
          // setTimeout((this.chatReady = true), 1000);

          var data = response.data;
          if (data.model && data.model.length) {
            var grouped = data.model.reduce((acc, item) => {
              acc[item.thread_id] = acc[item.thread_id] || item;
              return acc;
            }, {});

            that.threads = grouped;
            that.messages = data.model;
            var threads = Object.keys(that.threads);
            if (threads.length) {
              if (!this.existingThreadId) {
                if (!this.hideAssistantsList) {
                  that.selectThread(threads[threads.length - 1]);
                }
              } else {
                that.selectThread(
                  threads.find((t) => {
                    t.thread_id == this.existingThreadId;
                  })
                );
              }
            }
          }

          this.selectAssistant(a);
        });
    },
    selectThread(thread_id) {
      this.thread_id = thread_id;

      // this.messages
      //   .filter((m) => {
      //     return m.thread_id == this.thread_id;
      //   })
      //   .forEach((m) => {
      //     var msg = {
      //       _id: m._id,
      //       thread_id: this.thread_id,
      //       icon: m.role == "user" ? "mdi-account-circle" : "mdi-assistant",
      //       text: m.content,
      //       iconColor: m.role == "user" ? "primary" : "#F5F5F5",
      //       color: "white",
      //     };
      //     if (
      //       this.messages.some((r) => {
      //         return r._id != m._id;
      //       })
      //     ) {
      //       this.messages.push(msg);
      //     }
      //   });
    },
    initEventSource() {
      const evtSource = new EventSource(this.serverURL + "/assistant_stream");
      evtSource.onmessage = (event) => {
        console.log(JSON.parse(event.data));
      };
    },
    selectAssistant(a) {
      // if (!this.customInstructions) {
      if (a.message) {
        this.instructions = a.message
          .replace("[company_name]", this.companyName)
          .replace("[company_id]", this.companyId)
          .replace("[portal_id]", this.portal_id);
        // } else {
        //   this.instructions = this.customInstructions;
        // }
      }

      this.instructions += " Today is " + fun.getFullDate(new Date());

      this.assistantName = a.name;

      if (a.functions) {
        this.tools = this.tools.filter(
          (tool) =>
            tool &&
            tool.function &&
            a.functions.split(",").includes(tool.function.name)
        );
      }
      this.tools.push({
        type: "file_search",
      });
      this.tools.push({
        type: "file_search",
      });
      var file_ids = a.file_ids ? a.file_ids.split(",") : [];
      var tool_resources = { code_interpreter: { file_ids: file_ids } };
      var data = {
        _id: a._id,
        assistant_id: a.assistant_id,
        name: a.name,
        message: this.instructions,
        tools: this.tools,
        tool_resources: tool_resources,
      };
      axios
        .post(this.serverURL + "/select_assistant", data, {
          withCredentials: true,
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.error) {
            this.errorMessage = response.data.error;
            return;
          }
          this.assistant_id = response.data.assistant_id;
          this.chatReady = true;

          this.scrollToBottom();
          this.focusOnText();
        });
    },
    getModels() {
      var headers = this.headers;
      var that = this;
      axios
        .get("https://api.openai.com/v1/models", { headers: headers })
        .then((resp) => {
          console.log(resp);
          resp.data.data.forEach((m) => {
            that.models.push(m.id);
          });
        });
    },
    scrollToBottom() {
      const messageList = document.getElementById("message-list");

      try {
        messageList.scrollTop = messageList.scrollHeight;
      } catch (error) {
        //
      }
    },

    reload(c) {
      window.speechSynthesis.cancel();
      this.loading = false;
      if (c) {
        this.clear = true;
      }

      this.errorMessage = "";
      this.gptMessages = [];
      this.messages = [];
      this.getAssistants();
    },

    getAssistants() {
      // this.newMessage = this.defaultMessage;
      var that = this;
      axios
        .post(
          this.serverURL + "/get_data",
          {
            object_name: "chat_settings",
            all_records: true,
            db_name: "admin",
            // files: [
            //   {
            //     name: "list_items",
            //     path: "app_structure\\chat_prompt\\new_order.json",
            //   },
            // ],
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          // setTimeout((this.chatReady = true), 1000);

          var data = response.data;
          this.chats = data.model;
          if (that.assistantId) {
            that.assistantModel = data.model.find((m) => {
              return m._id == that.assistantId;
            });
          } else {
            that.assistantModel = data.model[0];
            that.assistantId = that.assistantModel._id;
          }

          if (
            that.companyName &&
            that.assistantModel &&
            that.assistantModel.text == "Customer Assistant"
          ) {
            that.initialMessage = "Welcome to " + this.companyName + " ";
          } else if (that.assistantModel) {
            that.initialMessage += that.assistantModel.initial_message;
          }
          if (this.defaultMessage) {
            this.initialMessage = this.defaultMessage;
          }
          try {
            that.getFunctions();
            this.getMessages(that.assistantModel);
          } catch (error) {
            //
          }

          // that.captionPrompt =
          //   that.assistantModel.getCaptionPrompt + this.captionInstructions;

          this.chatReady = true;
        });
    },
    convertMarkdownLinksToHTML(text) {
      // // Replace headers with bullets
      // text = text.replace(
      //   /^###\s*(.*)/gm,
      //   (match, p1) => `<ul><li>${p1.trim()}</li></ul>`
      // );

      // // Replace bold markdown syntax with strong tags, not adding new lines
      // text = text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

      // // Link replacement
      text = text.replace(this.captionPrompt, "");

      const linkRegex = /\[([^\]]+)]\(([^)]+)\)/g;
      text = text.replace(
        linkRegex,
        '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
      );

      // // Replace newline characters with <br/> only if they are not part of the list formatting
      // text = text.replace(/(?<!<\/li>)\n/g, "<br/>");

      // return text;
      // // return marked(text.join("\n\n"));
      var converter = new showdown.Converter();
      text = converter.makeHtml(text);
      const captionRegex = /<chat_caption>(.*?)<\/chat_caption>/g;
      let match = captionRegex.exec(text);
      if (match) {
        this.caption = match[1]; // Extract the content within the tags
        text = text.replace(captionRegex, ""); // Remove <chat_caption> tags and their content
      }
      // text = text.replace(/(?<!<\/li>)\n/g, "<br/><br/>");
      // text = text.replace(/(?:\r\n|\r|\n)/g, "<br>");
      return text;
    },
    stopAssistant() {
      this.loading = false;
      axios.post(this.serverURL + "/stop_assistant").then((response) => {
        this.successMessage = response.data.message;
      });
    },
    deleteThread(t) {
      var that = this;

      this.$refs.confirm
        .open("Delete Thread", "Confirm deleting " + t.caption + "?", {
          color: "red",
        })
        .then((confirm) => {
          if (confirm) {
            this.loading = true;
            axios
              .post(this.serverURL + "/delete_thread", {
                thread_id: t.thread_id,
              })
              .then((response) => {
                this.loading = false;
                // console.log(response.data);
                delete that.threads[t.thread_id];
                this.messages = [];
                this.getAssistants();

                // that.threads = that.threads.filter((a) => {
                //   return a.thread_id != t.thread_id;
                // });
              });
          }
        });

      //
    },
    getFunctions() {
      var that = this;
      if (that.assistantModel.functions) {
        axios.get("chat_prompt/ai_tools.json").then((response) => {
          var myFunctions = that.assistantModel.functions.split(",");
          response.data.forEach((t) => {
            if (t.type == "function") {
              if (myFunctions.includes(t.function.name)) {
                that.tools.push(t);
              }
            } else {
              that.tools.push(t);
            }
          });
        });
      }
    },
    cancelRequest() {
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel("Operation canceled by the user.");

        this.loading = false;
        this.stopAssistant();
      }
    },
    callOpenAI() {
      // this.initEventSource();
      var that = this;

      this.streaming = "";

      this.cancelTokenSource = axios.CancelToken.source();

      var data = {
        message: this.newMessage,
        user_id: this.user_id,
        assistant_id: this.assistant_id,
        thread_id: this.thread_id,
        delay: this.assistantModel.delay,
        instructions:
          this.instructions + " Today is " + fun.getFullDate(new Date()),
        tools: this.tools,
        no_streaming: this.noStreaming,
        images: this.images, //"https://portal85.moverai.com/user_images/room.jpg"
      };

      // if (!this.messages.length && this.captionPrompt) {
      //   data.message = this.newMessage + " " + this.captionPrompt;
      // } else {
      //   data.message = this.newMessage;
      // }

      that.newMessage = "";
      this.loading = true;

      if (this.systemMessage.content) {
        that.messages.push(this.systemMessage);
      }
      that.scrollToBottom();

      this.initSocket();
      setTimeout(function() {
        axios
          .post(that.serverURL + "/ask_assistant", data, {
            cancelToken: that.cancelTokenSource.token,
            withCredentials: true,
          })
          // .then((response) => {
          //   console.log(response);
          // that.loading = false;
          // that.chatReady = true;

          // // that.thread_id = d.thread_id;
          // // that.systemMessage.thread_id = that.thread_id;
          // var systemMessage = {
          //   content: that.streaming,
          //   thread_id: that.thread_id,
          //   role: "assistant",
          // };

          // if (systemMessage.content) {
          //   that.messages.push(systemMessage);

          //   that.focusOnText();
          //   that.scrollToBottom();
          // }
          // })
          .catch((error) => {
            this.loading = false;
            if (axios.isCancel(error)) {
              console.log("Request canceled by the user:", error.message);
            } else {
              console.error("Request failed:", error);
            }
          });
      }, 10);
    },

    checkIfFunction(resp, msg, systemMessage) {
      var that = this;
      if (resp.finish_reason == "function_call") {
        var func = that.functions.filter((f) => {
          return f.name == msg.function_call.name;
        })[0];
        that.excludedData = func.excludedData;
        // systemMessage.text += "<br> Please wait while I'm " + func.prompt;
        that.loadingText = func.prompt;
        if (systemMessage.text) {
          that.messages.push(systemMessage);
        }

        that.loading = true;
        // setTimeout(function() {
        that.callFunction(msg.function_call.name, msg.function_call.arguments);
        // }, 1000);
      }
    },
    resend() {
      this.loading = false;
      this.callOpenAI();
    },
    speechToText() {
      var that = this;
      var recognition = new (window.SpeechRecognition ||
        window.webkitSpeechRecognition ||
        window.mozSpeechRecognition ||
        window.msSpeechRecognition)();

      recognition.lang = "en-US"; // Set the language
      recognition.interimResults = false; // We want final results, not interim results
      recognition.maxAlternatives = 1; // We're only interested in the top result

      recognition.start(); // Start listening

      recognition.onresult = function(event) {
        console.log("You said: ", event.results[0][0].transcript);
        that.newMessage = event.results[0][0].transcript;
        that.callOpenAI();
      };

      recognition.onerror = function(event) {
        console.error("Error occurred in recognition: " + event.error);
      };
    },
    saveMessages(message) {
      var data = {
        metadata: {
          object_name: "ai_chat",
          portal_id: this.$root.portal_id,
        },
        model: {
          message: message,
          user_id: this.user_id,
          session: this.session.toString(),
        },
      };
      axios
        .post(this.serverURL + "/add_data", data, {
          withCredentials: true,
        })
        .then(function(response) {
          console.log(response.data);
        });
    },
    callFunction(functionName, args) {
      this.currentFunction = functionName;
      this[functionName](args);
    },
    responseFromFunction(resp) {
      this.loading = false;
      if (this.excludedData) {
        this.excludedData.forEach((e) => {
          delete resp[e];
        });
      }

      var msg = {
        role: "function",
        name: this.currentFunction,
        content: JSON.stringify(resp),
      };
      this.timeResponded = new Date();
      this.callOpenAI(msg);
    },

    async calculateRoute(model) {
      var route = await axios
        .post(this.serverURL + "/get_route", model, {
          withCredentials: true,
        })

        .catch((reason) => {
          console.log(reason);
        });
      if (route.data) {
        model.route = route.data[0];
        var distance = 0;
        var travelTime = 0;
        model.route.leg.forEach((l) => {
          distance += l.length;
          travelTime += l.travelTime;
        });
        model.distance = distance;
        model.mileage = (distance / 1.6 / 1000).toFixed(2);
        model.driving_time = (travelTime / 3600).toFixed(2);
      }

      return model;
    },
  },
  computed: {
    messageListHeight() {
      if (this.listHeight) {
        return this.listHeight;
      }
      return this.chatReady &&
        this.assistantModel &&
        this.assistantModel.show_all_threads
        ? window.innerHeight - 350
        : window.innerHeight - 100;
    },
  },
};
</script>
<style>
.assistant-list {
  max-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}
.thread-list {
  max-height: 20vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.bg-dark {
  /* background-color: #b5d9cb; */
}

.ai-background {
  background: white;
}

.chat-container {
  max-width: 300px;
}

.message {
  border-bottom: solid 1px;
  width: 100%;
}

.streaming p,
.message l {
  line-height: 30px;
}

.message p,
.message li {
  line-height: 30px;
}

.message h3,
.streaming h3 {
  line-height: 30px;
}

.chat-bubble {
  background-color: #e6f8f1;
  padding: 16px 28px;
  -webkit-border-radius: 20px;
  -webkit-border-bottom-left-radius: 2px;
  -moz-border-radius: 20px;
  -moz-border-radius-bottomleft: 2px;
  border-radius: 20px;
  border-bottom-left-radius: 2px;
  display: inline-block;
}

.typing {
  align-items: center;
  display: flex;
  height: 17px;
}

.typing .dot {
  animation: mercuryTypingAnimation 1.8s infinite ease-in-out;
  background-color: #6cad96;
  border-radius: 50%;
  height: 7px;
  margin-right: 4px;
  vertical-align: middle;
  width: 7px;
  display: inline-block;
}

.typing .dot:nth-child(1) {
  animation-delay: 200ms;
}

.typing .dot:nth-child(2) {
  animation-delay: 300ms;
}

.typing .dot:nth-child(3) {
  animation-delay: 400ms;
}

.typing .dot:last-child {
  margin-right: 0;
}

@keyframes mercuryTypingAnimation {
  0% {
    transform: translateY(0px);
    background-color: #6cad96;
  }

  28% {
    transform: translateY(-7px);
    background-color: #9ecab9;
  }

  44% {
    transform: translateY(0px);
    background-color: #b5d9cb;
  }
}

#message-list {
  /* height: calc(100vh - 350px); */
  /* height: 80vh; */
  /* border: solid dotted; */
  overflow-y: auto;
  overflow-x: hidden;
  width: calc(100% - 15px);
}

.image-block {
  overflow-y: auto;
  max-height: 200px;
}

.fixed {
  position: fixed;

  bottom: 0;
  height: 120px;
  /* width: 90%; */

  width: calc(100% - 25px);
}

.truncate-text-button {
  max-width: 200px;
  /* Adjust width as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
